import { render, staticRenderFns } from "./JourneyDetailEdit.vue?vue&type=template&id=51e62500&scoped=true"
import script from "./JourneyDetailEdit.vue?vue&type=script&lang=js"
export * from "./JourneyDetailEdit.vue?vue&type=script&lang=js"
import style0 from "./JourneyDetailEdit.vue?vue&type=style&index=0&id=51e62500&prod&lang=scss&scoped=true"
import style1 from "./JourneyDetailEdit.vue?vue&type=style&index=1&id=51e62500&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e62500",
  null
  
)

export default component.exports